// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1vwyF","selects":"Documents_selects__24vBX"};